import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'

/**
 * Landing page after Microsoft SSO. The backend has already verified the user
 * and set the httpOnly auth cookies, then redirected here. We exchange those
 * cookies for a stored access token (refresh) and load the profile, then send
 * the user to /home. Any failure bounces back to /login with an error.
 */
export default function AuthCallbackPage() {
  const navigate = useNavigate()
  const { refreshToken, loadFromStorage } = useAuthStore()

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      const ok = await refreshToken() // uses the httpOnly refresh cookie
      if (cancelled) return
      if (!ok) {
        navigate('/login?error=sso_failed', { replace: true })
        return
      }
      await loadFromStorage() // fetch /me, populate the store
      if (cancelled) return
      const authed = useAuthStore.getState().isAuthenticated
      navigate(authed ? '/home' : '/login?error=sso_failed', { replace: true })
    })()
    return () => {
      cancelled = true
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        background: '#F4F8FF',
        color: '#0D1F4E',
        fontFamily: 'system-ui, sans-serif',
      }}
    >
      <span
        style={{
          width: 34,
          height: 34,
          display: 'inline-block',
          border: '3px solid rgba(26,106,180,0.25)',
          borderTopColor: '#1A6AB4',
          borderRadius: '50%',
          animation: 'authcbSpin 0.8s linear infinite',
        }}
      />
      <p style={{ fontSize: '0.95rem', fontWeight: 600, margin: 0 }}>Signing you in…</p>
      <style>{`@keyframes authcbSpin { to { transform: rotate(360deg); } }`}</style>
    </div>
  )
}
